export default "__VITE_ASSET__CN7tmbIa__"